import { createReducer, on } from "@ngrx/store";
import {
    fetchMessages,
    fetchMessagesSuccess,
    fetchMessagesFailure,
    getMessage,
    getMessageSuccess,
    getMessageFailure,
    deleteMessage,
    deleteMessageSuccess,
    deleteMessageFailure,
    addMessage,
    addMessageSuccess,
    addMessageFailure
} from "./message.actions";

import { IState } from "@models/index";

const initialState: IState = {
  isLoaded: false,
  data: [],
  selectedItem: {},
  error: null,
  total: 0,
  maxPages: 0,
  perPage: 0,
  currentPage: 0
};

const _messageReducer = createReducer(
  initialState,
  on(fetchMessages, (state, { page, filterOptions, userId }) => {
    return state;
  }),
  on(fetchMessagesSuccess, (state, { messages }) => {
    const payload = {
      isLoaded: true,
      data: messages.data,
      total: messages.total,
      maxPages: messages.maxPages,
      perPage: messages.perPage,
      currentPage: messages.currentPage,
    };

    return { ...state, ...payload };
  }),
  on(fetchMessagesFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error
    };
    return { ...state, ...payload };
  }),
  on(getMessage, (state, { id }) => {
    const payload = {
      isSaved: false,
      isUpdated: false,
    };
    return { ...state, ...payload };
  }),
  on(getMessageSuccess, (state, { message }) => {
    const payload = {
      error: null,
      selectedItem: message
    };
    return { ...state, ...payload };
  }),
  on(getMessageFailure, (state, { error }) => {
    const payload = {
      error
    };
    return { ...state, ...payload };
  }),
  on(deleteMessage, (state, { id, to }) => {
    const payload = {
      isLoaded: false,
      isLoading: true
    };
    return { ...state, ...payload };
  }),
  on(deleteMessageSuccess, (state, { id, to }) => {
    const payload = {
      isLoaded: true,
      isLoading: false
      // data: state.data.filter(item => item.id !== id)
    };
    return { ...state, ...payload };
  }),
  on(deleteMessageFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      isLoading: false,
      error
    };
    return { ...state, ...payload };
  }),
  on(addMessage, (state, { message, from }) => {
    const payload = {
      isLoaded: false,
      isLoading: true
    };
    return { ...state, ...payload };
  }),
  on(addMessageSuccess, (state, { message, from }) => {
    const payload = {
      isLoaded: true,
      isLoading: false
    };
    return { ...state, ...payload };
  }),
  on(addMessageFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      isLoading: false,
      error
    };
    return { ...state, ...payload };
  }),
);

export function messageReducer(state, action) {
  return _messageReducer(state, action);
}
